import React from 'react';
import type { PropsWithChildren } from 'react';

const Box: React.FC<PropsWithChildren> = ({ children, ...rest }) => {
  return <div {...rest}>{children}</div>;
};

export default Box;
